/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { errorToast } from "../../helpers";
import { useGetAllfavPropertyMutation } from "../../service/Property";
import { GetPropertyDetail } from "../../types/General";
import PropertyGrid from "../../components/propertyGrid";
import Layout from "../../layout";

const FavProperty = () => {
  const [favProperty] = useGetAllfavPropertyMutation();
  const [favItems, setFavItems] = useState<GetPropertyDetail[]>([]);
  const [propertyDetail, setPropertyDetail] = useState<GetPropertyDetail[]>([]);

  const getFavProperty = async () => {
    try {
      const response = await favProperty({}).unwrap();
      if (response?.statusCode === 200) {
        setPropertyDetail(response?.data?.property);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      console.log(error);
    }
  };

  useEffect(() => {
    getFavProperty();
  }, []);

  const checkFavProperties = () => {
    const fav_data = propertyDetail
      .filter((item: GetPropertyDetail) => item?.isFavourite)
      .map((item: any) => item);
    setFavItems(fav_data);
  };

  useEffect(() => {
    checkFavProperties();
  }, [propertyDetail]);

  return (
    <Layout>
      <section className="propertiesList_sc u_spc">
        <div className="conta_iner">
          <div className="hd_1 mb_60 gap_p aic" style={{ marginTop: "40px" }}>
            <PropertyGrid
              propertyDetail={propertyDetail}
              favItems={favItems}
              setFavItems={setFavItems}
            />
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default FavProperty;
